<div class="h-100 d-flex flex-column">
    <h4 class="w-100 text-center mb-0">{{ totalAvailableCoins }}</h4>
    <div class="subtitle-1 text-center mb-2" cvLocalizedText langSection="Command_Center" langKey="Unspent_Coins">Unspent Coins</div>
    <div class="flex-fill">
        <canvas baseChart *ngIf="chartConfig"
            [type]="chartConfig.type"
            [datasets]="chartConfig.data.datasets"
            [labels]="chartConfig.data.labels"
            [options]="chartConfig.options"
            height="75%">
        </canvas>
    </div>
</div>